/**
 * should be global
 */
export const validateEmailAddressFormat = (email: string) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};
